import { Component, OnInit } from '@angular/core';
import { select } from '@angular-redux/store';
import { Observable, Subscription } from 'rxjs';
import { TranslationService } from '../../../common/services/languages/translation.service';
import { ApiResponseState } from '../../../store/api-response/api-response-state.model';
import { ApiResponseActions } from '../../../store/api-response/api-response-actions';
import { MatCard } from '@angular/material/card';
import { MatGridList, MatGridTile } from '@angular/material/grid-list';
import { NgIf, NgFor } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
    selector: 'app-survivor-account',
    templateUrl: './survivor-account.component.html',
    styleUrls: ['./survivor-account.component.scss'],
    imports: [MatCard, MatGridList, MatGridTile, NgIf, NgFor, TranslatePipe]
})
export class SurvivorAccountComponent implements OnInit {
  
  /**
  @Property to observe the redux customer store
  **/
  @select('api') readonly apiObservable: Observable<ApiResponseState>;
  /**
   * @property used to store the  subscription
   */
  public subscription: Subscription;
  /**
  * Property to store survivor account information
  **/
  public survivorAccountDetails: any[] = [];
  constructor(
    public translate: TranslationService
  ) {
  }
  ngOnInit() {
    this.subscription = this.apiObservable.subscribe((api) => {
      api.apiAction === ApiResponseActions.SET_SURVIVOR_ACCOUNT && api.survivorAccount['type'] === 'success' && !!api.survivorAccount['payload'] ?
        this.getSurvivorDetails(api.survivorAccount['payload']) : api.survivorAccount['type'] === 'error' ? this.getSurvivorDetailsError() : null;
    });
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  /**
   * @function getSurvivorDetails sets the survivor account info
   **/
  public getSurvivorDetails(customers): void {
    this.survivorAccountDetails = customers.map(customer => ({
      firstName: customer['firstName'],
      lastName: customer['lastName'],
      email: customer['emailAddresses']
    }));
  }
  /**
   * @function getSurvivorDetailsError sets the survivorAccountDetails to null upon call
   **/
  public getSurvivorDetailsError(): void {
    this.survivorAccountDetails = null;
  }
}
